import QuestionMarkCircle from '../src/QuestionMarkCircle/index.tsx';
export default QuestionMarkCircle;
